import { gql } from '@apollo/client';

export const GetPublicSharedMapQueryName = 'GetPublicSharedMap';

export const GET_PUBLIC_SHARED_MAP_QUERY = gql`
  query ${GetPublicSharedMapQueryName}($slug: String!) {
    getPublicSharedMap(slug: $slug) {
      settings {
        mapSettings {
          layer
          latitude
          longitude
          zoom
        }
        markerPoints {
          id
          label
          layer
          coordinate
          ordinal
        }
      }
    }
  }
`;
